import { render, staticRenderFns } from "./total-imports-exports-mp1c.vue?vue&type=template&id=bd09e8fc&"
import script from "./total-imports-exports-mp1c.vue?vue&type=script&lang=js&"
export * from "./total-imports-exports-mp1c.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd09e8fc')) {
      api.createRecord('bd09e8fc', component.options)
    } else {
      api.reload('bd09e8fc', component.options)
    }
    module.hot.accept("./total-imports-exports-mp1c.vue?vue&type=template&id=bd09e8fc&", function () {
      api.rerender('bd09e8fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-dsm-application/graphs/mp1c/total-imports-exports-mp1c.vue"
export default component.exports